import { render, staticRenderFns } from "./share_index.vue?vue&type=template&id=022e926e&"
import script from "./share_index.vue?vue&type=script&lang=js&"
export * from "./share_index.vue?vue&type=script&lang=js&"
import style0 from "./share_index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports